import { Grid } from "@mui/material";
import noNotificationSrc from "assets/images/illustration.png";
import { gray } from "configs/colors";

export const NotificationNoFound = () => {
  return (
    <Grid textAlign="center">
      <Grid marginBottom={4}>
        <img src={noNotificationSrc} alt="no-data" />
      </Grid>
      <Grid fontSize="16px" fontWeight="600" marginBottom={1}>
        No notification found
      </Grid>
      <Grid fontSize="14px" color={gray[600]}>
        You have no notification.
      </Grid>
    </Grid>
  );
};
